import React from 'react'
import { Cell } from '../../styles/styled-common'

// const MinMax = styled.span``
export default class SlotsCell extends React.PureComponent {
  render() {
    const {
      slots: { unlimited, max, min },
      ...props
    } = this.props
    return (
      <Cell {...props}>{unlimited ? 'Unlimited' : `${min}-${max}`} slots</Cell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/SlotsCell.jsx